import { baseUrl } from "utils/api";
import axios from "axios";

const token = localStorage.getItem("token");
const auth = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};

const addCategoryEndpoint = `${baseUrl}category`;
const addSupplierEndpoint = `${baseUrl}supplier`;
const addSystemUserEndpt = `${baseUrl}oath/`;
const addNewStockEndpt = "http://134.209.28.149:8080/stocks";
const addNewStockTypeEndpt = `${baseUrl}stockztype`;
const addNewStockClassEndpt = `${baseUrl}stockzclass`;
const addNewCustomerEndpt = `${baseUrl}customer`;
const addNewLevyEndpt = `${baseUrl}levies`;
const addNewCostCenterEndpt = `${baseUrl}costcenter`;
const addNewCurrencyEndpt = `${baseUrl}currencies`;
const addNewStoreEndp = `${baseUrl}storez`;
const addNewStoreLocationEndpt = `${baseUrl}storelocation`;
const addNewPkgUnitEndpt = `${baseUrl}unitz`;

export function addCategory(payload) {
  return axios.post(addCategoryEndpoint, payload, auth);
}

export function addSupplier(payload) {
  return axios.post(addSupplierEndpoint, payload, auth);
}

export function addNewSystemUser(payload) {
  return axios.post(addSystemUserEndpt, payload, auth);
}

export function updateSystemUser(payload) {
  return axios.put(addSystemUserEndpt, payload, auth);
}

export function addNewStockItem(payload) {
  return axios.post(addNewStockEndpt, payload, auth);
}

export function updateNewStockItem(payload) {
  return axios.put(addNewStockEndpt, payload, auth);
}

export function addNewStockCategoryEndpt(payload) {
  return axios.post(addCategoryEndpoint, payload, auth);
}

export function createNewStockType(payload) {
  return axios.post(addNewStockTypeEndpt, payload, auth);
}

export function createNewStockClass(payload) {
  return axios.post(addNewStockClassEndpt, payload, auth);
}

export function createNewCustomer(payload) {
  return axios.post(addNewCustomerEndpt, payload, auth);
}

export function createNewLevy(payload) {
  return axios.post(addNewLevyEndpt, payload, auth);
}

export function updateLevy(payload) {
  return axios.put(addNewLevyEndpt, payload, auth);
}

export function createNewCostCenter(payload) {
  return axios.post(addNewCostCenterEndpt, payload, auth);
}

export function updateCostCenter(payload) {
  return axios.put(addNewCostCenterEndpt, payload, auth);
}

export function createNewCurrency(payload) {
  return axios.post(addNewCurrencyEndpt, payload, auth);
}

export function updateCurrency(payload) {
  return axios.put(addNewCurrencyEndpt, payload, auth);
}

export function createNewStore(payload) {
  return axios.post(addNewStoreEndp, payload, auth);
}

export function updateStore(payload) {
  return axios.put(addNewStoreEndp, payload, auth);
}

export function createNewStoreLocation(payload) {
  return axios.post(addNewStoreLocationEndpt, payload, auth);
}

export function updateStoreLocation(payload) {
  return axios.put(addNewStoreLocationEndpt, payload, auth);
}

export function createNewPkgUnit(payload) {
  return axios.post(addNewPkgUnitEndpt, payload, auth);
}

export function updatePkgUnit(payload) {
  return axios.put(addNewPkgUnitEndpt, payload, auth);
}

// UPDATING NEW TRANSACTION
export function updateTransactionSale(payload) {
  return axios.post(`${baseUrl}transaction`, payload, auth);
}
